var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9167 14H1.08333C0.485331 14 0 13.552 0 13C0 12.448 0.485331 12 1.08333 12H24.9167C25.5147 12 26 12.448 26 13C26 13.552 25.5147 14 24.9167 14Z",
    fill: "#9E9E9E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9167 5.75529H1.08333C0.485331 5.75529 0 5.26996 0 4.67196C0 4.07395 0.485331 3.58862 1.08333 3.58862H24.9167C25.5147 3.58862 26 4.07395 26 4.67196C26 5.26996 25.5147 5.75529 24.9167 5.75529Z",
    fill: "#9E9E9E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9167 22H1.08333C0.485331 22 0 21.552 0 21C0 20.448 0.485331 20 1.08333 20H24.9167C25.5147 20 26 20.448 26 21C26 21.552 25.5147 22 24.9167 22Z",
    fill: "#9E9E9E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/Menu.0c7429c386fa42add2299310ff7c8278.svg";
export { ForwardRef as ReactComponent };